import styled from '@emotion/styled';
import { Divider, Input, Select, Space } from 'antd';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { BondEntity } from '../../../../../entities/bond.entity';
import { ConnectedUserEntity } from '../../../../../entities/ConnectedUserEntity';
import { DetenteurEntity } from '../../../../../entities/detenteur.entity';
import { ParameterType } from '../../../../../redux/userStore/reducer';
import { YELLOW } from '../../../../../shared/colors';
import { formatNum } from '../../../../../shared/constants';
import { getDetenteurs } from '../../../../panel/emissionBond/network';
import { getParameter } from '../../../network';

const Container = styled.div`
  font-family: Poppins-R;

  .ant-divider-inner-text {
    font-size: 14px;
  }
  .ant-divider-horizontal.ant-divider-with-text-left::after {
    border-top: 1px solid white;
  }

  .ant-divider-horizontal.ant-divider-with-text-left::before {
    border-top: 1px solid white;
  }

  p {
    margin: 0px;
  }

  > .operation {
    display: flex;
    justify-content: center;

    > .box {
      display: flex;
      justify-content: center;
      padding: 5px;
      border-radius: 10px;
      background-color: ${YELLOW};
      width: 120px;
    }
  }
`;

export const FractionOrder = ({
  bond,
  typeOpe,
  detailOpe,
  getSelectedDetenteur,
  getParam,
}: {
  bond: BondEntity;
  typeOpe: 'vente' | 'achat';
  detailOpe: any;
  getSelectedDetenteur: (detUrl: string) => void;
  getParam: (any) => void;
}) => {
  const connectedUser: ConnectedUserEntity = useSelector(
    (state: any) => state.userReducer,
  ).user;
  const [detenteurs, setDetenteurs] = useState<any[]>([]);
  const [param, setParam] = useState<any>({
    com_intermediation: 0,
    com_conservation: 0,
    droit_garde: 0,
    com_courtage: 0,
    mnt_global: 0,
    decote: 0,
    valaPay: 0,
    valaPercevoir: 0,
    com1: 0,
    com2: 0,
    com3: 0,
    com4: 0,
    montant: 0,
    prix: 10000,
    ...detailOpe,
  });
  const [parameter, setParameter] = useState<ParameterType>({
    id: '',
    com_intermediation: 0,
    com_conservation: 0,
    droit_garde: 0,
    com_courtage: 0,
    created_at: '',
  });

  useEffect(() => {
    getDetenteurs(connectedUser.id).then(({ data }) => {
      setDetenteurs(
        data.map((det: DetenteurEntity) => {
          return {
            label: `${det.code_referent} - ${det.nom} ${det.prenom || ''}`,
            value: det.url,
          };
        }),
      );
    });

    getParameter(1).then(({ data: response }) => {
      setParameter(response);
      console.log(response);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleMontantChange = (value: number) => {
    const prix = 10000;
    param.prix = prix;
    const qte = parseFloat((value / prix).toFixed(4));
    const datejour = new Date();
    const dateMature = new Date(bond.dateMaturite);
    const duree_annee =
      (dateMature.getTime() - datejour.getTime()) / (1000 * 60 * 24 * 365);
    const delta = parseFloat('0.' + duree_annee.toFixed(4).split('.')[1]);
    const prixTaux = (qte * 10000 * bond.tauxMarginal) / 100;
    const valaRestant = prixTaux * delta;
    const valaPercevoir = valaRestant.toFixed(2);
    const valaPayer = (prixTaux - valaRestant).toFixed(2);

    const com_intermediation = parameter.com_intermediation ?? 0;
    const com_conservation = parameter.com_conservation ?? 0;
    const droit_garde = parameter.droit_garde ?? 0;
    const com_courtage = parameter.com_courtage ?? 0;

    const com1 = typeOpe === 'achat' ? prix * qte * com_intermediation : 0;
    const com2 = typeOpe === 'achat' ? prix * qte * com_conservation : 0;
    const com3 = typeOpe === 'achat' ? prix * qte * droit_garde : 0;
    const com4 = typeOpe === 'achat' ? prix * qte * com_courtage : 0;

    const mnt_global = 10000 * qte;
    const decote = 100 - prix / 100;

    setParam((prev) => ({
      ...prev,
      montant: value,
      qte,
      datejour,
      valaPay: valaPayer,
      valaPercevoir,
      com_intermediation,
      com_conservation,
      droit_garde,
      com_courtage,
      com1,
      com2,
      com3,
      com4,
      mnt_global,
      decote,
      prix,
    }));

    getParam((prev) => ({
      ...prev,
      montant: value,
      qte,
      datejour,
      valaPay: valaPayer,
      valaPercevoir,
      com_intermediation,
      com_conservation,
      droit_garde,
      com_courtage,
      com1,
      com2,
      com3,
      com4,
      mnt_global,
      decote,
      prix,
    }));

    // Mettre à jour detailOpe.qte si tu veux aussi le propager vers le parent :
    detailOpe.qte = qte;
  };

  return (
    <Container>
      <Divider orientation='left' style={{ color: 'white', marginBottom: 2 }}>
        Montant de l'achat
      </Divider>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Space size={60}>
          <div className='coloriage1'>
            <Input
              className='qteInput'
              placeholder='Montant'
              type='number'
              min={bond.valeurNominale * 0.01}
              value={param.montant}
              onChange={(e) => handleMontantChange(parseFloat(e.target.value))}
            />
          </div>
        </Space>
      </div>
      <Divider orientation='left' style={{ color: 'white', marginBottom: 2 }}>
        Description de l'ordre
      </Divider>

      <div className='operation'>
        <Space className='box'>
          <p>{typeOpe === 'achat' ? 'ACHAT' : 'VENTE'} : </p>
          <p>{param.qte}</p>
        </Space>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Space size={30}>
          <div>
            <p>Date Valeur : </p>
            <p>Pays : </p>
            <p>Code : </p>
            <p>Instrument : </p>
          </div>
          <div>
            <p>{moment(param.datejour).format('DD/MM/YYYY')}</p>
            <p>{bond.pays}</p>
            <p>{bond.code}</p>
            <p>{bond.instrument}</p>
          </div>
        </Space>

        <Space size={30}>
          <div>
            <p>Dernier coupon: </p>
            <p>Taux int. : </p>
            <p>Taux rendement : </p>
            <p>Fréq. paiement : </p>
          </div>
          <div>
            <p>{moment(bond.dateMaturite).format('DD/MM/YYYY')}</p>
            <p>{bond.tauxMarginal} %</p>
            <p>0%</p>
            <p>{bond.frequencePaiement}</p>
          </div>
        </Space>
      </div>

      <Divider orientation='left' style={{ color: 'white', marginBottom: 2 }}>
        Montant
      </Divider>

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
        }}
      >
        <Space size={30}>
          <div>
            <p>Quantité Fractionné : </p>
            <p>Montant Global (A): </p>
            <p>Décôte (B):</p>
            <p>Coupon couru à payer (C):</p>
            <p>Coupon à percevoir: </p>
          </div>
          <div style={{ textAlign: 'right' }}>
            <p>{formatNum(param.qte)}</p>
            <p>{formatNum(parseInt(param.mnt_global.toFixed(2)))} XAF</p>
            <p>{formatNum(parseFloat(param.decote.toFixed(2)))}%</p>
            <p>{formatNum(parseInt(param.valaPay))} XAF</p>
            <p>{formatNum(parseInt(param.valaPercevoir))} XAF</p>
          </div>
        </Space>
        <Space size={30}>
          <div>
            <p>Com. Intermédiation({param.com_intermediation * 100}% - D):</p>
            <p>Com. conservation({param.com_conservation * 100}% - E):</p>
            <p>Droit de garde({param.droit_garde * 100}% - F): </p>
            <p>Com. de courtage({param.com_courtage * 100}% - G):</p>
          </div>
          <div style={{ textAlign: 'right' }}>
            <p>{formatNum(parseInt(param.com1.toFixed(2)))} XAF</p>
            <p>{formatNum(parseInt(param.com2.toFixed(2)))} XAF</p>
            <p>{formatNum(parseInt(param.com3.toFixed(2)))} XAF</p>
            <p>{formatNum(parseInt(param.com4.toFixed(2)))} XAF</p>
          </div>
          <div></div>
        </Space>
      </div>

      {typeOpe === 'achat' && (
        <>
          <Divider
            orientation='left'
            style={{ color: 'white', marginBottom: 2 }}
          >
            Client
          </Divider>
          <Space>
            <p>Détenteur : </p>
            <Select
              style={{ width: '350px' }}
              options={detenteurs}
              onChange={(val) => getSelectedDetenteur(val)}
            />
          </Space>
        </>
      )}

      <Divider orientation='left' style={{ color: 'white' }}>
        Total
      </Divider>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Space size={60}>
          <div>
            {typeOpe === 'achat' && <p>Total à payer (H= A*B + C+D+E+F+G): </p>}
            {typeOpe === 'vente' && (
              <p>Total à percevoir(H= A*B + C - (D+E+F+G)) : </p>
            )}
          </div>
          <div style={{ textAlign: 'right' }}>
            {/* <p>
              {typeOpe === 'achat'
                ? formatNum((detailOpe.prix * detailOpe.qte * 0.001) / 100)
                : 0}{' '}
              XAF
            </p> */}
            <p style={{ color: 'green', fontWeight: 'bold' }}>
              {typeOpe === 'achat'
                ? formatNum(
                    Math.round(
                      param.prix * param.qte +
                        param.prix *
                          param.qte *
                          (0.0027 + 0.002 + 0.003 + 0.002) +
                        parseFloat(param.valaPay),
                    ),
                  )
                : formatNum(
                    Math.round(
                      param.prix * param.qte + parseFloat(param.valaPay),
                    ),
                  )}{' '}
              XAF
            </p>
          </div>
          <div></div>
        </Space>
      </div>
    </Container>
  );
};
